export const WIDGET_ID = "result-awareness";
